/**
 * Init Google Maps object
 *
 * Events:
 * map:ready — triggered when Map object is ready
 */
 window.kMaps = (function() {
    var CoreOptions = {
            debug: false,
            mcOptions: {
                gridSize           : 50,
                maxZoom            : 50,
                minimumClusterSize : 500
            }
        },
        map,
        geocoder,
        distanceMatrix,
        pathIcon = 'M33,90c1.5,0,2.9-0.6,3.9-1.6c0.3-0.3,7.3-7.5,14.3-17.6C61,56.7,66,44.3,66,33.8C66,15.1,51.2,0,33,0 S0,15.1,0,33.8c0,10.5,5,23,14.8,37c7.1,10.1,14,17.3,14.3,17.6C30.1,89.4,31.5,90,33,90z M18.9,30.5c0-8,6.3-14.5,14.1-14.5 s14.1,6.5,14.1,14.5S40.8,45,33,45S18.9,38.5,18.9,30.5z'
        pathActiveColor = '#D1007F',
        pathInactiveColor = '#D3AFBE',
        visitedMarkerIcon = {},
        markerIcon = {};

    function kMaps(options)
    {
        // Default vars
        this.events   = [];
        this.markers  = {};
        this.tooltips = {};
        this.uniqID   = 0;


        // Set options
        var options = options || {};
        this.options = objectMerge(CoreOptions, options);

        // Check dependency
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            console.error('/!\ Google Maps JavaScript SDK is missing');
            return false;
        }

        // Init
        this.map = this.init();
        google.maps.event.addListenerOnce(this.map, 'idle', function() {
            //this.cluster = new MarkerClusterer(this.map, [], this.options.mcOptions);
            this.dispatch('map:ready');
            if ($(this.map.getDiv()).hasClass('js-no-clusterer')) {
                this.cluster.setMaxZoom(1);
                this.cluster.repaint();
            }
        }.bind(this));
    }

    /**
     * Initialize Google Maps
     * @return {object} Google Maps instance or false
     */
    kMaps.prototype.init = function()
    {
        if (!this.options.mapElement) {
            this._kdebug('error', '/!\ No valid DOM element provided');
            return false;
        }

        geocoder = new google.maps.Geocoder();
        distanceMatrix = new google.maps.DistanceMatrixService();

        visitedMarkerIcon = {
            path          : pathIcon,
            fillColor     : pathInactiveColor,
            fillOpacity   : 1,
            strokeColor   : pathInactiveColor,
            strokeOpacity : 1,
            strokeWeight  : 0,
            scale         : 0.55,
            size          : new google.maps.Size(37, 50),
            scaledSize    : new google.maps.Size(37, 50),
            anchor        : new google.maps.Point(30.45, 83),
            // anchor        : new google.maps.Point(29,83),
            origin        : new google.maps.Point(0,0)
        }

        markerIcon = {
            path          : pathIcon,
            fillColor     : pathActiveColor,
            fillOpacity   : 1,
            strokeColor   : pathActiveColor,
            strokeOpacity : 1,
            strokeWeight  : 0,
            scale         : 0.55,
            size          : new google.maps.Size(37, 50),
            scaledSize    : new google.maps.Size(37, 50),
            anchor        : new google.maps.Point(30.45, 83),
            // anchor        : new google.maps.Point(29,83),
            origin        : new google.maps.Point(0,0)
        }

        return new google.maps.Map(this.options.mapElement, this.options.mapOptions);
    }

    /*----------  Markers  ----------*/
    /**
     * Add Markers to the map
     * @param {object|array} markers Array of markers data
     */
    kMaps.prototype.setMarkers = function(markers, clearfirst)
    {
        var that = this
        var clearfirst = clearfirst || true

        if ((typeof markers === 'array' && markers.length) || (typeof markers === 'object' && Object.keys(markers).length)) {
            if (clearfirst) {
                this.removeMarkers();
            }

            this._kdebug('kMaps:setMarkers', markers);

            $.each(markers, function (markerIndex) {
                var markerData = markers[markerIndex];
                that._kdebug('kMaps:setMarkers:push', markerData);
                var markerLatLng = new google.maps.LatLng(markerData.lat, markerData.lng);
                var icon

                if (markerData.icon) {
                    icon = {
                        url    : markerData.icon,
                        size   : new google.maps.Size(40, 50),
                        scaledSize: new google.maps.Size(40, 50),
                    }
                } else icon = that.options.customMarker

                var marker = null;

                //consider non infobox markers as non-clusterable
                if ((typeof markerData.infobox == 'undefined') && markerData.icon) {
                    marker = new google.maps.Marker({
                        // map: that.map,
                        position : markerLatLng,
                        // title    : markerData.title,
                        icon : icon,
                        optimized: false,
                        url: markerData.url,
                        map: that.map
                    });
                }
                else{
                    marker = new google.maps.Marker({
                        // map: that.map,
                        position : markerLatLng,
                        // title    : markerData.title,
                        icon : icon,
                        optimized: false,
                        url: markerData.url
                    });

                    if (typeof markerData.infobox !== 'undefined') {
                        if (typeof markerData.infobox == 'string') {
                            that.addTooltip(marker, {
                                content: markerData.infobox
                            }, that.markers);
                        } else {
                            that.addTooltip(markerKey, markerData.infobox, that.markers);
                        }
                    }
                    // console.log(that.cluster, marker)
                    that.addMarker(marker);
                }

                that._kdebug('kMaps:setMarkers:marker', marker, that.markers);


                that.markers[that.uniqID] = marker;
                that.uniqID++;

                if (typeof markerData.url !== 'undefined' && typeof markerData.url == 'string') {
                    marker.addListener('click', function() {
                        window.location = marker.url
                    })
                }
            })

            // Auto set center & zoom from markers on map
            this.fitMapToMarkers();

            return this.markers;
        }

        return false
    }

    /**
     *  Fit the map to the bounds of the markers in the clusterer.
     */
    kMaps.prototype.fitMapToMarkers = function() {
        var that = this,
            markers =  Object.keys(that.markers).map(function(key) {return that.markers[key];});

        var bounds = new google.maps.LatLngBounds(),
            boundLimit = this.options.boundLimit && (markers.length < this.options.boundLimit) ? markers.length : this.options.boundLimit || markers.length,
            markersBounds = [];



        for (var i = 0; i < markers.length; i++) {
            if (typeof markers[i] !== 'undefined' && markersBounds.indexOf(markers[i].position.lat() + ',' + markers[i].position.lng()) < 0)
                markersBounds.push(markers[i].position.lat() + ',' + markers[i].position.lng())
        }

        boundLimit = (boundLimit > markersBounds.length ? markersBounds.length : boundLimit)

        for (var i = 0; i < boundLimit; i++) {
            if (typeof markersBounds[i] !== 'undefined') {
                var splited = markersBounds[i].split(',')
                var markersBoundsLatLng = new google.maps.LatLng(splited[0], splited[1]);
                bounds.extend(markersBoundsLatLng)
            }
        }

        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }

        setTimeout(function(){
            // if ($(that.map.getDiv()).hasClass('js-extend-fit-to-markers')) {
            //     google.maps.event.addListenerOnce(that.map, "idle", function() {
            //         that.map.setZoom( that.map.getZoom() - 1 )
            //     });
            // }
            that.map.fitBounds(bounds);
            // if ($(window).width() < 700) that.map.setZoom( that.map.getZoom() + 1 )
            if ($(that.map.getDiv()).hasClass('js-align-right')) {
                that.map.panBy(-350, 0)
            }
        }, 1000);
    };

    /**
     * Add markers passed as parameter
     * @param {object} markers markers object
     */
    kMaps.prototype.addMarkers = function(markers)
    {
        this._kdebug('info', 'kMaps:addMarkers', markers);

        var markers = markers || null;

        return this.setMarkers(markers, false);
    }

    /**
     * remove markers passed as parameters or all markers currently set
     * @param  {object} markers markers objects
     * @return {object}         new markers list currently on the map
     */
    kMaps.prototype.removeMarkers = function(markers)
    {
        this._kdebug('info', 'kMaps:removeMarkers', markers);

        if (typeof markers === 'undefined') {
            var markers = objectMerge({}, this.markers);
        }

        if (typeof this.cluster !== "undefined") this.cluster.removeMarkers(markers);

        for (var mk in markers) {
            var marker = markers[mk];

            this.cluster.removeMarker(marker);

            var k = objectIndexOf(this.markers, marker);

            if (k !== -1) {
                delete this.markers[k];
                var tk = this.tooltips[k];
                if (typeof tk !== 'undefined') {
                    tk.setMap(null);
                    delete this.tooltips[k];
                }
            }

            if(typeof marker.setMap === 'function'){
                marker.setMap(null);
            }
        }

        return this.markers;
    }

    /*----------  Tooltip  ----------*/
    /**
     * Create a tooltip and attach it to a marker
     * @param {object} marker         The marker to attach the tooltip
     * @param {object} tooltipOptions InfoWindow options ( https://developers.google.com/maps/documentation/javascript/reference?hl=fr#InfoWindowOptions )
     */
    kMaps.prototype.addTooltip = function(marker, tooltipOptions, markers)
    {
        this._kdebug('info', 'kMaps:addTooltip', marker, tooltipOptions);

        if (typeof marker !== 'undefined' && typeof tooltipOptions === 'object') {
            var tooltip = new google.maps.InfoWindow(tooltipOptions);

            if (typeof this.tooltips[this.uniqID] === 'undefined') {
                this.tooltips[this.uniqID] = tooltip;
            }

            marker.addListener('click', function(ev){
                var that = this
                this._kdebug('info', 'kMaps:tooltip:click', tooltip, ev);
                this.closeAllTooltips();

                if ($(this.map.getDiv()).siblings('.js-tooltip-container').length) {
                    var $tooltipContainer = $(this.map.getDiv()).siblings('.js-tooltip-container')
                    var $slider = $(this.map.getDiv()).closest('.js-owl-carousel')
                    var first = true

                    for (var markerIndex in markers) {
                        if (first) first = false
                        else {
                            if (markers[markerIndex] != marker) markers[markerIndex].setIcon(visitedMarkerIcon)
                            else marker.setIcon(markerIcon)
                        }
                    }


                    $tooltipContainer.html(tooltip.content)

                    var $tooltipContentDom = $tooltipContainer.children()
                    first = true
                    $tooltipContentDom.find('button.close').click( function () {
                        $(this).parents('.js-tooltip-container').html('')
                        for (var markerIndex in markers) {
                            if (first) first = false
                            else markers[markerIndex].setIcon(markerIcon)
                        }
                    })

                    $slider.trigger('refresh.owl.carousel')
                    autoHeightSlider($slider)
                    // $("html, body").animate({ scrollTop: $tooltipContainer.offset().top }, 300)
                } else {
                    tooltip.open(this.map, marker)
                }
            }.bind(this));

            return tooltip;
        }

        return false;
    }

    /**
     * Close all the tooltips
     * @return {boolean} True when finished
     */
    kMaps.prototype.closeAllTooltips = function()
    {
        this._kdebug('info', 'kMaps:closeAllTooltips');

        for (var tk in this.tooltips) {
            this.tooltips[tk].close();
        }

        return true;
    }

    /*----------  Events  ----------*/
    /**
     * attach an event listener to the instance
     * @param {string}   event    the event name
     * @param {Function} callback the callback function to call when event is dispatched
     */
    kMaps.prototype.addEventListener = function(event, callback)
    {
        this.events[event] = this.events[event] || [];
        if (this.events[event]) {
            this.events[event].push(callback);
        }
    }

    /**
     * removes an event listener from the instance
     * @param  {string}   event    the event name
     * @param  {Function} callback the callback function attached to the event
     * @return {boolean}  True if successfully removed (if found)
     */
    kMaps.prototype.removeEventListener = function(event, callback)
    {
        if (this.events[event]) {
            var listeners = this.events[event];
            for (var i = listeners.length-1; i>=0; --i) {
                if (listeners[i] === callback) {
                    listeners.splice(i, 1);
                    return true;
                }
            }
        }
        return false;
    }

    /**
     * Dispatch the event and call the callback function
     * @param  {string} event the event to dispatch
     */
    kMaps.prototype.dispatch = function(event)
    {
        this._kdebug('info', 'kMaps:event:dispatch', event);
        if (this.events[event]) {
            var listeners = this.events[event], len = listeners.length;
            while (len--) {
                listeners[len](this);   //callback with self
            }
        }
    }

    /*----------  Debug  ----------*/
    kMaps.prototype._kdebug = function()
    {
        if (this.options.debug && console) {
            var args = arguments;
            if (["log","info","warn","error"].indexOf(args[0]) !== -1) {
                type = args[0];
                delete args[0];
            } else {
                type = 'log';
            }

            Function.apply.call.call(console[type], console, args);
        }
    }

    /*----------  Helpers  ----------*/
    var objectMerge = function(objTo, objFrom)
    {
        for (var i in objFrom) {
            if (objFrom.hasOwnProperty(i)) {
                objTo[i] = objFrom[i];
            }
        }
        return objTo;
    };

    var objectIndexOf = function(obj, value)
    {
        for (var k in obj) {
            if (obj[k] == value) {
                return k;
            }
        }
    }

    // Array clone - By David Walsh
    Array.prototype.clone = function()
    {
        return this.slice(0);
    };

    // Array Remove - By John Resig (MIT Licensed)
    Array.prototype.remove = function(from, to)
    {
        var rest = this.slice((to || from) + 1 || this.length);
        this.length = from < 0 ? this.length + from : from;
        return this.push.apply(this, rest);
    };


    return kMaps;
})();
